export interface IngresosGastos {
  id?: string;
  idInmueble: string;
  fecha: string; // "YYYY-MM-DD"
  cantidad: number;
  concepto: string;
  categoria: string;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export const CATEGORIAS_INGRESO = ['Ingresos'] as const;
export const CATEGORIAS_GASTO = ['Gastos ordinarios', 'Gastos directos', 'Gastos reserva', 'Gastos reinversión'] as const;
export const CATEGORIA_ORDER = ['Ingresos', 'Gastos ordinarios', 'Gastos directos', 'Gastos reserva', 'Gastos reinversión'];
